import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { OrderShuttleVM } from '../../../../../../models/orderModel';

@Component({
  selector: 'app-back-office24-ordershuttlebus-arrival',
  templateUrl: './back-office24-ordershuttlebus-arrival.component.html',
  styleUrl: './back-office24-ordershuttlebus-arrival.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusArrivalComponent implements OnInit {
  @Input() orderShuttleVM: OrderShuttleVM;

  constructor() { }

  ngOnInit(): void {
  }

}
